import React, { useContext } from 'react';
import {
	Accordion,
	useAccordionButton,
	Card,
	AccordionContext,
} from 'react-bootstrap';
import { Dash, Plus } from 'react-bootstrap-icons';
import TreeView from '../components/TreeView';
import { DRUPAL_URL, ISADG_METADATA } from '../utilities/globals';

function CustomToggle({ children, eventKey }) {
	const { activeEventKey } = useContext(AccordionContext);
	const decoratedOnClick = useAccordionButton(eventKey, () => {});
	const isCurrentEventKey = activeEventKey === eventKey;

	return (
		<button
			type='button'
			className={isCurrentEventKey ? 'open' : ''}
			style={{ backgroundColor: 'transparent' }}
			onClick={decoratedOnClick}
		>
			{children}{' '}
			<span className='off'>
				<Plus />
			</span>
			<span className='on'>
				<Dash />
			</span>
		</button>
	);
}

export function renderAncestorTab(ancestor, startsWith = 1) {
	let parser = new DOMParser();
	let xmlDoc = parser.parseFromString(ancestor?.metadata, 'application/xml');
	/* console.log(
		xmlDoc
			?.querySelector('metadata > identificacion > nivel_descripcion')
			?.textContent?.toLowerCase()
	); */
	return (
		<React.Fragment key={`${startsWith}-${Math.random()}`}>
			{ancestor.parent &&
				renderAncestorTab(ancestor.parent, startsWith + 1)}
			<Card key={startsWith}>
				<Card.Header className='g-md-ia'>
					<CustomToggle eventKey={startsWith}>
						{xmlDoc
							?.querySelector(
								'metadata > identificacion > nivel_descripcion'
							)
							?.textContent?.toLowerCase() ??
							'UNIDAD DOCUMENTAL SIMPLE'}
					</CustomToggle>
				</Card.Header>
				<Accordion.Collapse eventKey={startsWith} key={startsWith}>
					<Card.Body>
						{DisplayMetadata({
							metadata: ancestor?.metadata,
							title:
								xmlDoc
									?.querySelector(
										'metadata > identificacion > nivel_descripcion'
									)
									?.textContent?.toLowerCase() !==
								'unidad documental simple',
							xmlDoc,
						})}
						{/* <DisplayMetadata
							metadata={ancestor?.metadata}
							xmlDoc={ancestor?.metadata}
							key={`card-body-${startsWith}`}
						/> */}
					</Card.Body>
				</Accordion.Collapse>
			</Card>
		</React.Fragment>
	);
}

const DislayMultiple = ({ label, value, key, node }) => {
	//console.log({ label, value, node });
	// console.log(value);
	if (node.length === 0)
		return (
			<div className='md-ln' key={`${key}-cont`}>
				<div className='md-lbl' key={`${key}-lbl`}>
					{label}:{' '}
				</div>
				<div
					className='md-cnt'
					key={`${key}-value`}
					dangerouslySetInnerHTML={{ __html: value }}
				></div>
			</div>
		);
	else {
		return (
			<div className='md-ln' key={`${key}-cont`}>
				<div className='md-lbl' key={`${key}-lbl`}>
					{label}:{' '}
				</div>
				<div className='md-cnt' key={`${key}-value`}>
					{Array.from(node).map((item, index) => {
						//console.log(item);
						return (
							<div
								key={`${key}-value-${index}`}
								style={{
									display: index === 0 ? 'inline' : 'block',
								}}
								dangerouslySetInnerHTML={{
									__html: item.outerHTML,
								}}
							/>
						);
					})}
				</div>
			</div>
		);
	}
};
const DisplayMetadata = ({ metadata, title = true, xmlDoc }) => {
	//console.log(metadata);
	//console.log(xmlDoc);
	return ISADG_METADATA?.map(
		(meta_item, indx) =>
			xmlDoc
				?.querySelector(`metadata > ${meta_item?.field}`)
				?.hasChildNodes() && (
				<div
					className='md-info'
					key={`${meta_item.field}-${indx}-${meta_item.label}`}
				>
					{title && <div className='md-area'>{meta_item.label}</div>}
					{meta_item.children.map((item, index) => {
						return (
							xmlDoc
								?.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								)
								?.hasChildNodes() &&
							DislayMultiple({
								label: item.label,
								value: xmlDoc.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								).textContent,
								node: xmlDoc.querySelector(
									`metadata > ${meta_item.field} > ${item.field}`
								).children,
								key: `${item.field}-${index}}`,
							})
						);
					})}
				</div>
			)
	);
};

export default function GLIFOSMetadataViewer(props) {
	let { itemInfo, collection = false, inventory = null } = props;
	//console.log(itemInfo);

	let parser = new DOMParser();
	let xmlDoc = parser.parseFromString(itemInfo?.metadata, 'application/xml');

	return !collection ? (
		<Accordion defaultActiveKey='1' className='g-md-vw'>
			{(+itemInfo?.children_count > 0 || itemInfo?.ancestors) && (
				<Card>
					<Card.Header className='g-md-ia'>
						<CustomToggle eventKey='0'>
							ESQUEMA DE CLASIFICACIÓN
						</CustomToggle>
					</Card.Header>
					<Accordion.Collapse eventKey='0'>
						<Card.Body>
							<TreeView
								isadg={
									itemInfo?.ancestors?.root ??
									itemInfo?.isadg?.code
								}
								selected={itemInfo?.isadg?.code}
								inViewer
								root_father={
									itemInfo?.ancestors?.root ??
									itemInfo?.isadg?.code
								}
							/>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			)}
			{itemInfo?.ancestors && renderAncestorTab(itemInfo.ancestors, 2)}
			<Card>
				<Card.Header className='g-md-ia'>
					<CustomToggle eventKey='1'>
						{xmlDoc.querySelector(
							'metadata > identificacion > nivel_descripcion'
						)?.textContent ?? 'UNIDAD DOCUMENTAL SIMPLE'}
					</CustomToggle>
				</Card.Header>
				<Accordion.Collapse eventKey='1'>
					<Card.Body>
						{DisplayMetadata({
							metadata: itemInfo?.metadata,
							title:
								xmlDoc
									?.querySelector(
										'metadata > identificacion > nivel_descripcion'
									)
									?.textContent?.toLowerCase() !==
								'unidad documental simple',
							xmlDoc,
						})}
					</Card.Body>
				</Accordion.Collapse>
			</Card>
			{inventory?.payload?.file_id && (
				<Card>
					<Card.Header className='g-md-ia'>
						<button
							type='button'
							style={{
								backgroundColor: 'transparent',
							}}
							onClick={() =>
								window.open(
									`${DRUPAL_URL}${inventory.payload.file_id}`,
									'_blank'
								)
							}
						>
							Inventario
						</button>
					</Card.Header>
				</Card>
			)}
		</Accordion>
	) : (
		DisplayMetadata({
			metadata: itemInfo?.metadata,
			title:
				xmlDoc
					?.querySelector(
						'metadata > identificacion > nivel_descripcion'
					)
					?.textContent?.toLowerCase() !== 'unidad documental simple',
			xmlDoc,
		})
	);
}
